// Public Module - Root Reducers
// This file aggregates all public-related reducers

// Note: Auth reducer is exported separately in the main reducers file
// as it needs special handling for persistence

// If you have other public reducers, add them here
const publicReducers = {
  // Add public reducers here if needed
}

export default publicReducers

